export class User {
  firstName : string = ''
  username: string = ''
  token: string = ''
  role:string = 'guest'
  state:boolean = false
}
